export function isChrome() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /chrome|crios/.test(userAgent) && !/edg|edge|opr|opera|fxios|samsungbrowser/.test(userAgent);
}

export function isChromiumEdge() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /edg/.test(userAgent);
}

export function isLegacyEdge() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /edge/.test(userAgent) && !/edg/.test(userAgent);
}

export function isEdge() {
  return isChromiumEdge() || isLegacyEdge();
}

export function isFirefox() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /firefox|fxios/.test(userAgent);
}

export function isIE() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /msie|trident/.test(userAgent);
}

export function isSafari() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /safari/.test(userAgent) && !/chrome|crios|edg|edge|fxios|opr|opera/.test(userAgent);
}

const Browser = {
  chrome: 'chrome',
  edge: 'edge',
  firefox: 'firefox',
  ie: 'ie',
  safari: 'safari',
  unknown: 'unknown'
}

export function getBrowser() {
  if (isChrome()) return Browser.chrome;
  else if (isEdge()) return Browser.edge;
  else if (isFirefox()) return Browser.firefox;
  else if (isSafari()) return Browser.safari;
  else if (isIE()) return Browser.ie;
  else return Browser.unknown;
}

export default getBrowser;
